import { accountState } from '@/app/model/store/domain/types'
import { userType } from '@/app/model/store/domain/const'

export default <accountState> {
  accountData: [],
  allFieldData: [],
  choiceAccountType: userType.USER_TYPE_ALL,
  orderNum: 1,
  sort: 'asc',
  searchText: ''
}
